import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import ServicePage from "@/views/ServicePage.vue";
import AboutPage from "@/views/AboutPage.vue";
import BlogPage from "@/views/BlogPage.vue";
import TeamPage from "@/views/TeamPage.vue";

const routes = [
  {
    path: "/dental/",
    name: "home",
    component: HomeView,
    meta: {
      title: "Dental",
    },
  },
  {
    path: "/dental/Service",
    name: "service",
    component: ServicePage,
    meta: {
      title: "Dental - Services",
    },
  },
  {
    path: "/dental/About",
    name: "About",
    component: AboutPage,
    meta: {
      title: "Dental - About",
    },
  },
  {
    path: "/dental/Team",
    name: "Team",
    component: TeamPage,
    meta: {
      title: "Dental - Team",
    },
  },
  {
    path: "/dental/Blog",
    name: "Blog",
    component: BlogPage,
    meta: {
      title: "Dental - Blog",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  document.title = to.meta?.title ?? "dental";
});

export default router;
